import { createFileRoute } from '@tanstack/react-router';

import { MyWorkPage } from '@/features/me/my-work';

export const Route = createFileRoute('/_app/me/work/')({ component: MyWorkPage });
